import { API_END_POINTS } from "../../constant/config";
import Filter from "../../utils/Filter";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_MARKETING_BANNERS, CREATE_MARKETING_BANNER, GET_SINGLE_MARKETING_BANNER, UPDATE_MARKETING_BANNER, DELETE_MARKETING_BANNER, UPLOAD_BANNER } from "../type"

// Fetch Banner
export const fetchMarketingBanners = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_MARKETING_BANNERS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.data.docs,query);
        dispatch({
            type: GET_MARKETING_BANNERS,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const Bannerscount = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_MARKETING_BANNERS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        dispatch({
            type: GET_MARKETING_BANNERS,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Create Banner
export const createMarketingBanner = (data) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.CREATE_MARKETING_BANNER;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, data)
        return dispatch({
            type: CREATE_MARKETING_BANNER,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: CREATE_MARKETING_BANNER,
                payload: error.response.data,
            });
        }
    }
};

// Get Single Banner
export const fetchSingleMarketingBanner = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_MARKETING_BANNER;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_MARKETING_BANNER,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update Banner
export const updateMarketingBanner = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_MARKETING_BANNER;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_MARKETING_BANNER,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_MARKETING_BANNER,
                payload: error.response.data,
            });
        }
    }
};

// Delete Banner
export const deleteMarketingBanner = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_MARKETING_BANNER;
        const response = await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        dispatch({
            type: DELETE_MARKETING_BANNER,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Upload Banner
export const uploadMarketingBanner = (data) => async (dispatch) => {
    const config = {     
        headers: { 'content-type': 'multipart/form-data' }
    }

    try {
        const apiEndpoint = API_END_POINTS.UPLOAD_BANNER;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, data, config)
        return dispatch({
            type: UPLOAD_BANNER,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPLOAD_BANNER,
                payload: error.response.data,
            });
        }
    }
};